import React from "react";

import { appConstants } from "../../config/app-constants";

type Props = {};

const ProfitsInLieu173Hint: React.FC<Props> = (props: Props) => {
	return (
		<>
			<section className="text-center">
				<img
					src={`${appConstants.basePath}/assets/images/hints/section-17-three-12ba.png`}
					alt="profits in lieu 17(3) from form 12BA"
					className="img-fluid d-block mx-auto my-4"
				/>
			</section>
		</>
	);
};

export default ProfitsInLieu173Hint;
